export default {
    show: () => {
        document.body.classList.add('mdb-loader-open');
        
        const backdrop = document.createElement('div');
        const spinner = document.createElement('div');
        
        backdrop.className = 'mdb-loader-component modal-backdrop show';
        spinner.className = 'mdb-loader-component download-loader';
        
        document.body.appendChild(backdrop);
        document.body.appendChild(spinner);
    },
    hide: () => {
        document.body.classList.remove('mdb-loader-open');
        
        document.querySelectorAll('.mdb-loader-component')
            .forEach(n => n.remove());
    },
    showProgressCursor: () => document.body.classList.add('cursor-progress'),
    stopProgressCursor: () => document.body.classList.remove('cursor-progress')
};